import { useEffect } from "react";

const PROPERTY_ID = (import.meta.env.VITE_TAWK_PROPERTY_ID as string) || "";
const WIDGET_ID = (import.meta.env.VITE_TAWK_WIDGET_ID as string) || "default";

/**
 * Loads the Tawk.to script once. Renders nothing visible itself; Tawk injects
 * its own floating widget. Intentionally a no-op when no property id is set
 * so DEV doesn't show a stale chat from another tenant.
 */
export default function ChatWidget() {
  useEffect(() => {
    if (!PROPERTY_ID) return;
    if (document.getElementById("tawk-script")) return;

    // @ts-expect-error tawk globals
    window.Tawk_API = window.Tawk_API || {};
    // @ts-expect-error tawk globals
    window.Tawk_LoadStart = new Date();

    const s = document.createElement("script");
    s.id = "tawk-script";
    s.async = true;
    s.src = `https://embed.tawk.to/${PROPERTY_ID}/${WIDGET_ID}`;
    s.charset = "UTF-8";
    s.setAttribute("crossorigin", "*");
    document.body.appendChild(s);
  }, []);

  return null;
}
